"use client"

import { Swords } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `SwordsIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const SwordsIcon = component(Icon)({ as: Swords })
